module.exports = __webpack_public_path__ + "img/Down.406045ae.svg";